import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=efa165e0&scoped=true&"
import script from "./ProfileIcon.vue?vue&type=script&lang=js&"
export * from "./ProfileIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=efa165e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa165e0",
  null
  
)

export default component.exports